import cx from 'classnames'
import Styles from './CaptionsContent.module.scss'
import { useRef, useState } from 'react'
import { Text } from 'blaze-ui/Text/Text'
import { CaptionsContentProps } from '../Types'
import { useHover } from '@react-aria/interactions'
import { useButton } from '@react-aria/button'
import { mergeProps } from '@react-aria/utils'
import { useApplyCaption } from 'components/ChatAssistant/useApplyCaption'

interface CaptionProps {
  fileId: string
  caption: string
  index: number
}

const Caption = ({ fileId, caption, index }: CaptionProps) => {
  const [isTruncated, setIsTruncated] = useState(true)
  const needsTruncation = caption.length > 100
  const displayText = isTruncated && needsTruncation ? caption.slice(0, 100) + '...' : caption
  const { applyCaption } = useApplyCaption({ fileId })

  const applyRef = useRef<HTMLButtonElement>(null)
  const moreLessRef = useRef<HTMLSpanElement>(null)
  const { hoverProps, isHovered } = useHover({})
  const { hoverProps: moreLessHoverProps, isHovered: isMoreLessHovered } = useHover({})
  const { buttonProps } = useButton({ onPress: () => applyCaption(caption) }, applyRef)
  const { buttonProps: moreLessButtonProps } = useButton(
    { elementType: 'span', onPress: () => setIsTruncated(!isTruncated) },
    moreLessRef,
  )

  return (
    <button
      ref={applyRef}
      className={cx(Styles.caption, { [Styles.hovered]: isHovered })}
      {...mergeProps(hoverProps, buttonProps)}
    >
      <div className={Styles.header}>
        <Text variant="label" color="var(--dark-100)">
          Option {index + 1}
        </Text>
      </div>
      <div>
        <div className={Styles.captionText}>{displayText}</div>
        {needsTruncation && (
          <span
            className={cx(Styles.moreLessText, { [Styles.hovered]: isMoreLessHovered })}
            {...mergeProps(moreLessButtonProps, moreLessHoverProps)}
            ref={moreLessRef}
          >
            {isTruncated ? 'more' : 'less'}
          </span>
        )}
      </div>
    </button>
  )
}

export const CaptionsContent = ({ content }: CaptionsContentProps) => {
  return (
    <div className={Styles.captions}>
      {content.content.map((caption, index) => (
        <Caption key={index} fileId={content.design_id} caption={caption} index={index} />
      ))}
    </div>
  )
}
